import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

var DEFAULT_LANG = "zh";
const ALLOWED_LANGS = ['en', 'zh'];
var savedLan = localStorage.getItem('lan');

if (savedLan && ALLOWED_LANGS.includes(savedLan)) {
  DEFAULT_LANG = savedLan;
} else if (savedLan) {
  localStorage.setItem('lan', 'zh');
}

const locales = {
  en: require("./i18n/en.json"),
  zh: require("./i18n/zh.json"),
};
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales
});

export default i18n;
